import HealthcenterGroupingView from "@/grouping/views/HealthcenterGroupingView.vue";
import {RouteRecordRaw} from "vue-router";

const routes: RouteRecordRaw[] = [
    {
        path: '/grouping',
        name: 'grouping',
        component: HealthcenterGroupingView
    }
];

export default routes;
